import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';
import CONSTANTS from '../constants';
import PaymentService from '../services/PaymentService';

export function getPaymentProcessor(locationId) {
  return async (dispatch) => {
    try {
      let processor = await PaymentService.getPaymentProcessor(locationId);
      let decryptData = AES.decrypt(Object.keys(processor).length === 0 ? '' : processor.parameters, 'plugd_p_key');
      processor.parameters = decryptData.toString(Utf8);
      dispatch({ type: CONSTANTS.ACTIONS.PAYMENTS.PROCESSOR.GET, processor });
    } catch (error) {
      console.log('Error: ', error);
    }
  };
}
